import './image-text.scss';
import GLightbox from 'glightbox';
import Swiper from 'swiper/swiper-bundle';

export default () => {
	new Swiper( '.js-image-slider', {
		slidesPerView: 1,
		loop: true,
	} );

	const videoSlider = GLightbox( {
		selector: '.glightbox3',
	} );

	function spaceKeyHandler ( event ) {
		if ( event.code === 'Space' ) {
			let iframe = document.querySelector( '#glightbox-body iframe' );

			if ( iframe ) {
				let iframeWindow = iframe.contentWindow;

				iframeWindow.postMessage( '{"event":"command","func":"pauseVideo","args":""}', '*' );
			}
		}
	}

	videoSlider.on( 'open', () => {
		document.addEventListener( 'keydown', spaceKeyHandler );
	} );

	videoSlider.on( 'close', () => {
		document.removeEventListener( 'keydown', spaceKeyHandler );
	} );
};
